import React from "react";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";

const AboutInfo = () => {
  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          // paddingTop: "60px",
          // paddingBottom: "60px",
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>

        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">About Us </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>About Us</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-about-area section-space rs-about-thirteen">
        <div className="container">
          <div className="row align-items-xxl-center g-5">
            {/* Left Images */}
            <div className="col-xl-6 col-lg-5">
              <div className="rs-about-thumb-wrapper">
                <div
                  className="rs-about-thumb has-large rs-image scroll_reveal reveal_left reveal-active"
                  style={{
                    transform: "translate(0px, 0px)",
                    opacity: 1,
                    visibility: "inherit",
                  }}
                >
                  <img
                    decoding="async"
                    src="/assets/images/about/about-thumb-20.png"
                    alt="About Large"
                    style={{ transform: "translate(0px, 0px)" }}
                  />
                </div>

                <div
                  className="rs-about-thumb has-small rs-image scroll_reveal reveal_right reveal-active"
                  style={{
                    transform: "translate(0px, 0px)",
                    opacity: 1,
                    visibility: "inherit",
                  }}
                >
                  <img
                    decoding="async"
                    src="/assets/images/about/about-thumb-21.png"
                    alt="About Small"
                    style={{ transform: "translate(0px, 0px)" }}
                  />
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-xl-6 col-lg-7">
              <div className="rs-about-wrapper">
                <div className="rs-about-content-wrapper">
                  <div className="rs-section-title-wrapper">
                    <span className="rs-section-subtitle has-theme-orange justify-content-start">
                      <FaPlay color="#EA5501" size={12} />
                      About Us
                    </span>

                    <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                      About Eque International
                    </h2>

                    <p
                      className="descrip text-justify"
                      style={{ textAlign: "justify" }}
                    >
                      Eque International is a dynamic and diversified business
                      conglomerate with a legacy of growth spanning over three
                      decades. Established in 1990, the International began its
                      journey with small-scale production of tobacco products
                      and soap, laying the foundation for a strong and resilient
                      enterprise.
                    </p>
                    <p
                      className="descrip text-justify"
                      style={{ textAlign: "justify" }}
                    >
                      Driven by vision, innovation, and commitment to
                      excellence, Eque International has steadily expanded its
                      footprint across multiple industries, transforming into a
                      multi-sector organization with nine sister concerns.
                    </p>
                  </div>

                  {/* Tabs */}
                  <div className="rs-about-tab">
                    <ul className="nav nav-pills" role="tablist">
                      {/* <li className="nav-item">
                        <button
                          className="nav-link active"
                          data-bs-toggle="pill"
                          data-bs-target="#history"
                          type="button"
                        >
                          Our History
                        </button>
                      </li> */}

                      <li className="nav-item">
                        <button
                          className="nav-link active"
                          data-bs-toggle="pill"
                          data-bs-target="#mission"
                          type="button"
                        >
                          Our Mission
                        </button>
                      </li>

                      <li className="nav-item">
                        <button
                          className="nav-link"
                          data-bs-toggle="pill"
                          data-bs-target="#vision"
                          type="button"
                        >
                          Our Vision
                        </button>
                      </li>
                    </ul>
                  </div>

                  {/* Tab Content */}
                  <div className="tab-content rs-about-tab-anim">
                    {/* <div className="tab-pane fade show active" id="history">
                      <div className="rs-about-tab-content">
                        <p>
                          Welcome to Industrie, Link leading industry innovator
                          with Link rich history of excellence. We empower
                          industries and drive progress globally.
                        </p>

                        <div className="rs-about-feature-list">
                          <div className="rs-list-item has-theme-orange">
                            <ul>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                Quality Control System
                              </li>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                Building Quality Industrial
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/* Mission */}
                    <div className="tab-pane fade show active" id="mission">
                      <div className="rs-about-tab-content">
                        {/* <p>
                          Our mission is to provide world class industrial
                          solutions and maintain high quality production
                          systems.
                        </p> */}

                        <div className="rs-about-feature-list">
                          <div className="rs-list-item has-theme-orange">
                            <ul className="mb-4">
                              <li>
                                <i className="fa-regular fa-check"></i>
                                To deliver high-quality products and services
                              </li>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                To ensure customer satisfaction and trust
                              </li>
                            </ul>

                            <ul>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                To contribute to economic development and
                                employment
                              </li>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                To expand responsibly into new markets and
                                industries
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Vision */}
                    <div className="tab-pane fade" id="vision">
                      <div className="rs-about-tab-content">
                        <p>
                          To become a leading industrial and business
                          International recognized for excellence, innovation,
                          and sustainable growth both locally and globally.
                        </p>

                        {/* <div className="rs-about-feature-list">
                          <div className="rs-list-item has-theme-orange">
                            <ul>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                Quality Control System
                              </li>
                              <li>
                                <i className="fa-regular fa-check"></i>
                                Building Quality Industrial
                              </li>
                            </ul>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  {/* Author + Button */}
                  {/* <div className="rs-about-author-info">
                    <div className="rs-about-btn">
                      <Link
                        className="rs-btn has-theme-orange has-icon has-bg"
                        to="/about"
                      >
                        Explore More
                      </Link>
                    </div>

                    <div className="rs-about-author">
                      <div className="rs-about-author-thumb">
                        <img
                          src="/assets/images/user/user-thumb-04.png"
                          alt="author"
                        />
                      </div>

                      <div className="rs-about-author-sign-thumb">
                        <img
                          src="/assets/images/shape/sign-shape.png"
                          alt="sign"
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutInfo;
